import { render, staticRenderFns } from "./ResumeFooter.vue?vue&type=template&id=08396939&"
import script from "./ResumeFooter.vue?vue&type=script&lang=js&"
export * from "./ResumeFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ResumeFooter.vue"
export default component.exports